/**
 * Workforce Module Layout
 *
 * Simple wrapper for workforce pages when rendered inline in the admin dashboard.
 * The admin dashboard (App.tsx) handles authentication and provides the main layout.
 *
 * When embedded in App.tsx, this layout just provides consistent spacing/styling.
 *
 * Workforce Module Capabilities:
 * - Candidates: Recruitment pipeline management
 * - Roles: Workforce role definitions (CHW, HAA, etc.)
 * - Certifications: Certification lifecycle tracking
 * - Curricula: Training curriculum management
 * - Mentoring: Mentoring programs and cohorts
 * - Roster: Active workforce deployment
 * - Skills Gap: AI-powered candidate matching
 */

import React, { ReactNode } from 'react';
import { useAppTranslation } from '@/contexts/TranslationContext';

interface WorkforceLayoutProps {
  children: ReactNode;
}

/**
 * Simplified layout for workforce pages when embedded in admin dashboard.
 * Authentication is handled by App.tsx, so no auth checks needed here.
 */
export default function WorkforceLayout({ children }: WorkforceLayoutProps) {
  // When rendered inline in App.tsx, the parent dashboard already provides
  // the main layout, sidebar, and authentication. This wrapper just provides
  // consistent styling for workforce page content.
  return (
    <div className="workforce-module">
      {children}
    </div>
  );
}
